import type { KanbanCommentsStore } from './interfaces'

export const getters = {
  isLoading: (state: KanbanCommentsStore): KanbanCommentsStore['loading'] => state.loading,
  getComments: (state: KanbanCommentsStore): KanbanCommentsStore['comments'] => state.comments,
  getCustomerId: (state: KanbanCommentsStore): KanbanCommentsStore['customerId'] => state.customerId,
}